import { missingInput, divisionByZero } from '../warnings';
import { formulaOk, formulaUnknown, type FormulaResult } from './types';

/** SPEC-008 §22 — CPA = investment / target actions (a funnel/stage metric). */
export function cpa(investment: number | null, actions: number | null): FormulaResult {
  const explanation = {
    metric: 'cpa',
    formula: 'investment / actions',
    inputs: { investment, actions },
    result: null,
    unit: 'minor_currency_per_action',
  };
  if (investment === null || actions === null) {
    return formulaUnknown(explanation, [missingInput('Investment and action count are both required to calculate CPA.')]);
  }
  if (actions === 0) {
    return formulaUnknown(explanation, [divisionByZero('CPA is undefined when there are zero actions.')]);
  }
  return formulaOk(investment / actions, { ...explanation, result: investment / actions }, []);
}
